import React, { useState } from 'react';
import { connect } from 'react-redux';
import { forgotPassword } from '../../reducers/forgotPassword';

import ForgotPassword from './ForgotPassword';

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  onForgotPassword: email => dispatch(forgotPassword(email)),
});

const ForgotPasswordState = ({ onForgotPassword }) => {
  const [email, setEmail] = useState('');

  return (
    <ForgotPassword
      onEmailChange={setEmail}
      onForgotPassword={() => onForgotPassword(email)}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordState);
